export default "__VITE_ASSET__DVIQOT4k__"